import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="account-type"
// Hides customer provisioning fields (organization, trial, demo) when the
// "admin" account type radio is selected, and the new-person fields when an
// existing user is picked as owner.
export default class extends Controller {
  static targets = ["radio", "provisioning", "existingUser", "newUser"];

  connect() {
    this.update();
  }

  update() {
    const selected = this.radioTargets.find((radio) => radio.checked);
    // Boolean on purpose: toggle() with an undefined force flips the class
    // instead of setting it, which happens when there are no radios at all.
    const isAdmin = Boolean(selected && selected.value === "admin");
    this.provisioningTargets.forEach((target) => target.classList.toggle("hidden", isAdmin));

    const existingOwner = !isAdmin && this.hasExistingUserTarget && this.existingUserTarget.value !== "";
    this.newUserTargets.forEach((target) => target.classList.toggle("hidden", existingOwner));
  }
}
